import React from 'react'
import { Row, Col, Form, Button } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import { setField } from '../slices/tradeWindowSlice';

// Define expiryOptions and strikePrices
const getExpiryOptions = () => {
    // Get current IST date
    const today = new Date();
    const istToday = new Date(today.getTime() + (5.5 * 60 * 60 * 1000));
    
    // Generate upcoming Thursdays dynamically
    const dates = [];
    let current = new Date(istToday);
    
    // Include today if it's Thursday
    if (istToday.getDay() === 4) {
        const nextDay = new Date(istToday);
        nextDay.setDate(istToday.getDate() + 7);
        const isLastThursday = (nextDay.getMonth() !== istToday.getMonth());
        const dateStr = istToday.toISOString().split('T')[0];
        dates.push(dateStr);
    }
    
    // Get future Thursdays
    while (dates.length < 20) {
        current.setDate(current.getDate() + 1);
        if (current.getDay() === 4) {
            const dateStr = current.toISOString().split('T')[0];
            dates.push(dateStr);
        }
    }
    return dates;
};

const expiryOptions = getExpiryOptions();
const strikePrices = []; // Populate with actual strike prices

function TradingFormWC() {
    const formData = useSelector((state) => state.formData) || {};
    const dispatch = useDispatch();
    
    const handleInputChange = (e) => {
        dispatch(setField({ name: e.target.name, value: e.target.value }));
    };

    const handleSellCall = () => {
        // Logic to sell call
    };

    const handleBuyCall = () => {
        // Logic to buy call
    };

    const handleClosePositions = () => {
        // Logic to close all positions
    };

    const handleCancelOrders = () => {
        // Logic to cancel all orders
    };

    return (
        <div>
            <Row>
                <Col>
                    {/* Trading Form */}
                    <Row className="mb-4">
                        <Col>
                            <Form>
                                <Row className="g-3">
                                    <Col md={3}>
                                        <Form.Group>
                                            <Form.Label className="text-danger">Broker</Form.Label>
                                            <Form.Select 
                                                name="broker"
                                                value={formData.broker}
                                                onChange={handleInputChange}
                                            >
                                                <option value="">Please select broker to trade</option>
                                                <option value="broker1">Broker 1</option>
                                                <option value="broker2">Broker 2</option>
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>

                                    <Col md={2}>
                                        <Form.Group>
                                            <Form.Label>Exchange</Form.Label>
                                            <Form.Select 
                                                name="exchange"
                                                value={formData.exchange}
                                                onChange={handleInputChange}
                                            >
                                                <option value="NSE">NSE</option>
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>

                                    <Col md={2}>
                                        <Form.Group>
                                            <Form.Label>Symbol</Form.Label>
                                            <Form.Select
                                                name="symbol"
                                                value={formData.symbol}
                                                onChange={handleInputChange}
                                            >
                                                <option value="NSE_INDEX|Nifty 50">NIFTY</option>
                                                <option value="NSE_INDEX|Nifty Bank">BANKNIFTY</option>
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>

                                    <Col md={2}>
                                        <Form.Group>
                                            <Form.Label>Expiry</Form.Label>
                                            <Form.Select
                                                name="expiryDate"
                                                value={formData.expiryDate}
                                                onChange={handleInputChange}
                                            >
                                                <option value="">Select Expiry</option>
                                                {expiryOptions.map((expiry, index) => (
                                                    <option key={index} value={expiry}>{expiry}</option>
                                                ))}
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>

                                    <Col md={2}>
                                        <Form.Group>
                                            <Form.Label>Call Strike</Form.Label>
                                            <Form.Select
                                                name="callStrike"
                                                value={formData.callStrike}
                                                onChange={handleInputChange}
                                            >
                                                <option value="">Select Call Strike</option>
                                                {strikePrices && strikePrices.map((strike, index) => (
                                                    <option key={index} value={strike}>{strike}</option>
                                                ))}
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>

                                    <Col md={2}>
                                        <Form.Group>
                                            <Form.Label>Put Strike</Form.Label>
                                            <Form.Select
                                                name="putStrike"
                                                value={formData.putStrike}
                                                onChange={handleInputChange}
                                            >
                                                <option value="">Select Put Strike</option>
                                                {strikePrices && strikePrices.map((strike, index) => (
                                                    <option key={index} value={strike}>{strike}</option>
                                                ))}
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <Row className="g-3 mt-2">
                                    <Col md={2}>
                                        <Form.Group>
                                            <Form.Label>Quantity</Form.Label>
                                            <Form.Control
                                                type="number"
                                                name="quantity"
                                                value={formData.quantity}
                                                onChange={handleInputChange}
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col md={2}>
                                        <Form.Group>
                                            <Form.Label>Market Protection %</Form.Label>
                                            <Form.Select
                                                name="marketProtection"
                                                value={formData.marketProtection}
                                                onChange={handleInputChange}
                                            >
                                                <option value="10">10%</option>
                                                <option value="20">20%</option>
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>

                                    <Col md={3}>
                                        <Form.Group>
                                            <Form.Label>Position Type</Form.Label>
                                            <Form.Select
                                                name="positionType"
                                                value={formData.positionType}
                                                onChange={handleInputChange}
                                            >
                                                <option value="F&O positions only">F&O positions only</option>
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </Form>
                        </Col>
                        
                    </Row>

                    {/* Trading Actions */}
                    <Row className="mb-4">
                        <Col>
                            <div className="d-flex gap-2">
                                <Button variant="danger" onClick={handleSellCall}>
                                    Sell Call
                                </Button>
                                <Button variant="success" onClick={handleBuyCall}>
                                    Buy Call
                                </Button>
                                <Button variant="outline-primary" onClick={handleClosePositions}>
                                    Close All Positions
                                </Button>
                                <Button variant="outline-secondary" onClick={handleCancelOrders}>
                                    Cancel All Orders
                                </Button>
                            </div>
                        </Col>
                    </Row>
                </Col>

               
            </Row>
        </div>
    )
}

export default TradingFormWC
